import React, { Component } from 'react';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Typeaehad css
import 'react-bootstrap-typeahead/css/Typeahead.css';

import 'react-datepicker/dist/react-datepicker.css';

// Import Main styles for this application
import './scss/style.css';



import { DefaultLayout } from './containers';
// Pages
import { Landing } from './views/Pages';


class App extends Component {
  render() {
    return (
      localStorage.getItem('user') ? <DefaultLayout /> : <Landing />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js